<template>
    <div class="campo-form">
        <Checkbox v-model="isChecked" :binary="true" :id="fieldId" :name="name" />
        <div class="checkbox-container">
            <label :for="fieldId" class="checkbox-label">
                <span class="checkbox-text">{{ label }}</span>
                <span style="color: #bb2a17" v-if="required">*</span>
            </label>
            <slot class="actions" name="acoes"></slot>
        </div>
    </div>
</template>

<script setup>
import { ref, defineProps } from 'vue';

defineProps({
    label: String,
    required: Boolean,
    name: String,
    helpText: String,
    modelValue: [Boolean, String],
    checkboxText: String,
    acceptText: String,
});

const isChecked = ref(false);
const fieldId = ref(`checkbox-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`);
</script>

<style scoped lang="scss">
.campo-form {
    display: flex;
    flex-direction: row;

    .checkbox-container {
        padding-left: 8px;
        display: flex;
        align-items: center;
        font-weight: 700;
        justify-content: space-between;
        gap: 10px;
        width: 100%;
    }
}
</style>
